import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';

export interface FilterChip {
  key: string;
  label: string;
  value: string;
  /** false = se muestra pero no se puede quitar (p. ej. el periodo). */
  removable?: boolean;
}

/**
 * Fila de filtros activos debajo de `.filter-card`: contador "X de Y",
 * un chip por filtro (con ✕) y "Limpiar todo".
 * El contador solo aparece cuando hay algo filtrado (count ≠ total).
 */
@Component({
  selector: 'app-filter-chips',
  standalone: true,
  imports: [MatIconModule, MatButtonModule, MatTooltipModule],
  template: `@if (chips.length > 0 || showCount) {
<div class="filter-chips">
  @if (showCount) {<span class="filter-chips__count">{{ count }} de {{ total }} {{ noun }}</span>}
  @for (chip of chips; track chip.key) {
    <span class="filter-chip"><b>{{ chip.label }}:</b>&nbsp;{{ chip.value }}@if (chip.removable !== false) {<button type="button" class="filter-chip__remove" [matTooltip]="'Quitar filtro de ' + chip.label" (click)="remove.emit(chip.key)"><mat-icon>close</mat-icon></button>}</span>
  }
  @if (hasRemovable) {<button mat-button type="button" class="filter-chips__clear" (click)="clear.emit()"><mat-icon>filter_alt_off</mat-icon> Limpiar todo</button>}
</div>
}`,
})
export class FilterChipsComponent {
  @Input() chips: FilterChip[] = [];
  @Input() count: number | null | undefined = null;
  @Input() total: number | null | undefined = null;
  @Input() noun = 'registros';
  @Output() remove = new EventEmitter<string>();
  @Output() clear = new EventEmitter<void>();

  get showCount(): boolean {
    return this.count != null && this.total != null && this.count !== this.total;
  }
  get hasRemovable(): boolean {
    return this.chips.some(c => c.removable !== false);
  }
}
